import type { ICoordinate } from '../../../../../../../models/coordinate.model';

export default class CoordinateHelper {
  public static equals(c1: ICoordinate | undefined, c2: ICoordinate | undefined): boolean {
    if (!c1 || !c2) return false;
    return c1.latitude === c2.latitude && c1.longitude === c2.longitude;
  }
}
